import { render, staticRenderFns } from "./Form49MenuExtFood.vue?vue&type=template&id=71e5cbb4&scoped=true&"
import script from "./Form49MenuExtFood.vue?vue&type=script&lang=js&"
export * from "./Form49MenuExtFood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e5cbb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VCheckbox,VFlex,VIcon,VLayout,VToolbar,VToolbarTitle})
